import type { ParameterType } from '$shared/constants/ParameterType';
import type { IProviderProfileImportSource } from '$shared/interfaces/api/IProviderProfileImportSource';
import BaseModel from '$shared/models/BaseModel';

export class ProviderProfileImportSource extends BaseModel<IProviderProfileImportSource> {
  public get source(): string {
    return this.response?.source || '';
  }

  public get name(): string {
    return this.response?.name || '';
  }

  public get requiredParameterTypes(): ParameterType[] {
    return this.response?.requiredParameterTypes || [];
  }
}
